module.exports = __webpack_public_path__ + "static/Truck29-1c1f5bb2afa4233fe0eafa527421ead1.png";